// extracted by mini-css-extract-plugin
module.exports = {"main":"CountWithTitle_main__2T-am"};